import { Textarea } from "@/components/ui/textarea";

const EXAMPLES = [
  "Replace carpet in 2 bedrooms with LVP",
  "Patch water-damaged drywall in the ceiling",
  "Finish my basement into a family room",
];

export const DescriptionStep = ({ value, onChange }) => (
  <div className="space-y-4">
    <Textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Describe the project in your own words. Which rooms, what's there now, and what you'd like it to look like."
      rows={7}
      maxLength={4000}
      data-testid="description-textarea"
      className="rounded-2xl border border-slate-200 bg-white p-4 text-[17px] shadow-soft leading-relaxed focus-visible:ring-0 focus-visible:border-[color:var(--brand)]"
    />
    <div className="flex flex-wrap gap-2">
      {EXAMPLES.map((ex, i) => (
        <button key={ex} type="button" data-testid={`description-example-${i}`}
          onClick={() => onChange(value ? `${value}\n${ex}` : ex)}
          className="rounded-full border border-slate-200 bg-white px-3 py-2 text-sm text-slate-600 active:scale-95 transition-transform">
          + {ex}
        </button>
      ))}
    </div>
  </div>
);
